import React, {useState, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import { Grid, Link, styled, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import AlertInfo from '../../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';

interface TopSearch {
    searchQuery: string;
    count: number;
}

const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#fafafa',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

function SearchEngineTopSearchesSummary() {

    const [topSearches, setTopSearches] = useState<TopSearch[]>();

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    //payload
    useEffect(() => {
        getTopSearchQueries();
    },[])

    const getTopSearchQueries = async () => {
        await fetch(`/ItDashboard/GetTopSearchQueries`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: ItDashboard - GetTopSearchQueries',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    setTopSearches(result.result);
                }
            }
            )
    }

    return (
        <>
            <Grid item xs={10} marginBottom={2} >
                <Typography color={'blue'} variant="subtitle1" marginBottom={2}>
                    Top 10 searches in the last 30 days
                </Typography>
                {topSearches && topSearches.length > 0 &&
                    <TableContainer>
                        <Table stickyHeader size="small">
                            <TableBody>
                                {topSearches.map((search: TopSearch, index) =>
                                    <StyledTableRow key={index}>
                                        <TableCell>
                                            <Link variant="subtitle2" href={`https://www.ocpf.us/PublicSearch/Index?q=${search.searchQuery}`} target="blank" underline="none">{search.searchQuery}</Link>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" align="right">#{search.count}</Typography>
                                        </TableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>}
            </Grid>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>
    );
}

export default SearchEngineTopSearchesSummary 

